import React, { useContext } from "react";
import { Skeleton } from "primereact/skeleton";
import { ContactProfileDetailsContext } from "app/uicomponents/macrocomponents/ContactLayout";

function ContactDashBoardHeader() {
  const { contactFirstName, isOpen } = useContext(ContactProfileDetailsContext);
  return (
    <div
      style={{
        height: "80px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
      className="w-full fixed z-50 border-b-1 border-[#DEE2E6]"
    >
      <div className={`h-full  ${isOpen ? "w-[13rem]" : "w-32"}`} />
      <div className="h-full" style={{ flex: isOpen ? 4 : 6 }}>
        <div className="flex justify-between items-center h-full conthrax-font border-b-1 border-[#DEE2E6]">
          {contactFirstName ? (
            <p className={`text-2xl font-semibold py-3 ${!isOpen ? "ml-5" : ""} text-[#0A090B]`}>
              {`Welcome Back, ${contactFirstName}!`}
            </p>
          ) : (
            <Skeleton width="20rem" height="3rem" borderRadius="16px" className="mb-2" />
          )}
        </div>
        <hr
          className={`border-[#DEE2E6] w-full mt-[-5px] ${isOpen ? "ml-[-28px]" : "ml-[12px]"}`}
        />
      </div>
    </div>
  );
}

export default ContactDashBoardHeader;
